export const BREAKPOINT_REM = {
  mobile: '48rem',
  tablet: '64rem',
  desktopSmall: '80rem',
  desktopMedium: '90rem',
  desktopLarge: '120rem',
}

export const PAGE_REM = {
  maxContentWidth: '80rem',
  collapsedSidebarWidth: '3.5rem',
  sidebarWidth: '20.25rem',
}
